// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileHeader_root__3SibW"};